import type { EnvConfig } from '@/types/config/env-config.types';

/**
 * 取得必填環境變數
 */
const resolveRequiredEnv = (key: keyof ImportMetaEnv): string => {
    const value = import.meta.env[key];
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new Error(`BridgeEnvConfig 初始化錯誤: 缺少欄位 ${String(key)}`);
    }

    return value.trim();
};

/**
 * 建立 bridge 環境設定實例 (供 runtime 對外橋接使用)
 * 直接讀取 Vite 環境變數，供 Razor runtime 輸出
 */
export const createBridgeEnvConfig = (): EnvConfig => {
    return {
        VUE_APP_SHOP_CODE: resolveRequiredEnv('VITE_APP_SHOP_CODE'),
        VUE_APP_SHOP_CODE_2: resolveRequiredEnv('VITE_APP_SHOP_CODE_2'),
        EC_BASE_URL: resolveRequiredEnv('VITE_APP_EC_BASE_URL'),
        MALL_BASE_URL: resolveRequiredEnv('VITE_APP_MALL_BASE_URL'),
        OAUTH_BASE_URL: resolveRequiredEnv('VITE_APP_OAUTH_BASE_URL'),
    };
};
